import { doc, setDoc } from '@firebase/firestore';
import { Fragment, useState } from 'react';
import { database } from '../firebase';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useTranslation } from 'react-i18next';

const CreateRecipeForm = () => {
  const { t } = useTranslation();

  const [titleState, setTitleState] = useState('');
  const [markupState, setMarkupState] = useState('');
  const [weightState, setWeightState] = useState(1000);
  const [ingNameState, setIngNameState] = useState('');
  const [ingPercentageState, setIngPercentageState] = useState('');

  const [ingredientsState, setIngredientsState] = useState([]);

  const createRecipe = event => {
    event.preventDefault();

    const id = `${titleState.toLowerCase().split(' ').join('-')}-${Math.floor(
      Math.random() * 10000
    )}`;

    setDoc(doc(database, 'recipes', id), {
      id,
      date: new Date(),
      title: titleState,
      markup: markupState,
      path: `/${id}`,
      standardWeightInGrams: weightState,
      ingredients:
        ingNameState && ingPercentageState
          ? [
              ...ingredientsState,
              { name: ingNameState, percentage: ingPercentageState }
            ]
          : ingredientsState
    });

    setTimeout(() => {
      setTitleState('');
      setMarkupState('');
      setWeightState(1000);
      setIngredientsState([]);
      setIngNameState('');
      setIngPercentageState('');
    });
  };

  return (
    <>
      <h2>{t('createRecipe')}</h2>
      <form onSubmit={createRecipe}>
        <label htmlFor="title">{t('title')}</label>
        <input
          type="text"
          name="title"
          id="title"
          required
          value={titleState}
          onChange={e => setTitleState(e.target.value)}
        />
        <br />
        <br />
        <CKEditor
          editor={ClassicEditor}
          onChange={(event, editor) => {
            const data = editor.getData();
            setMarkupState(data);
          }}
          data={markupState}
        />
        <br />
        <br />
        <label htmlFor="weight">{t('weight')}</label>
        <input
          type="number"
          name="weight"
          id="weight"
          required
          value={weightState}
          onChange={e => setWeightState(e.target.value)}
        />
        <br />
        <br />
        <div className="ingredients-form-wrapper">
          <h3>{t('ingredients')}</h3>
          {ingredientsState.map((ing, index) => (
            <Fragment key={index}>
              <span className="bold">{t('ingredientColon')}</span> {ing.name}
              <br />
              <span className="bold">{t('percentageColon')}</span>{' '}
              {ing.percentage}
              <br />
              <br />
            </Fragment>
          ))}
          <label htmlFor="ingredient-name">{t('ingredient')}</label>
          <input
            type="text"
            name="ingredient-name"
            id="ingredient-name"
            value={ingNameState}
            onChange={e => setIngNameState(e.target.value)}
          />
          <br />
          <br />
          <label htmlFor="ingredient-percentage">{t('percentage')}</label>
          <input
            type="number"
            name="ingredient-percentage"
            id="ingredient-percentage"
            value={ingPercentageState}
            onChange={e => setIngPercentageState(e.target.value)}
          />
          <br />
          <br />
          <button
            onClick={e => {
              e.preventDefault();
              if (ingNameState && ingPercentageState) {
                setIngredientsState(prevState => [
                  ...prevState,
                  { name: ingNameState, percentage: ingPercentageState }
                ]);
                setTimeout(() => {
                  setIngNameState('');
                  setIngPercentageState('');
                });
              }
            }}
          >
            {t('addIngredient')}
          </button>
          <br />
          <br />
        </div>
        <br />
        <button
          type="submit"
          disabled={
            !ingredientsState.length && (!ingNameState || !ingPercentageState)
          }
        >
          {t('submit')}
        </button>
      </form>
    </>
  );
};

export default CreateRecipeForm;
